<template>
  <div id="order_history_detail">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <!--  メインコンテンツ  -->
    <div class="main_content">
      <main class="flex_content">
        <div class="title">
          <h2>ご注文履歴詳細</h2>
        </div>
        <table>
          <thead>
            <tr>
              <th  class="order_th" colspan="5"><font color="ffffff">注文情報</font></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="order_td" colspan="3">注文番号</td>
              <td colspan="2">{{ orderData.orderNo }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">ご注文日時</td>
              <td colspan="1">{{ getDate(orderData.odDate) }}</td>
              <td colspan="1" class="center" v-if="!isBeforeDate">
                <button type="submit" class="main_btn cancel_btn" @click="estimate(orderData.orderNo)">見積書</button>
              </td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">ご請求金額</td>
              <td colspan="2">{{ formatPrice(orderPrice.totalPrice) }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">決済方法</td>
              <td colspan="2">{{ paymentType }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">施主名</td>
              <td colspan="2">{{ orderData.infoName }}</td>
            </tr>
          </tbody>
        </table>
        <dd-order-price
          :orderPrice="orderPrice"
          v-if="!isBeforeDate"
        />
        <table>
          <thead>
            <tr>
              <th  class="order_th" colspan="5"><font color="ffffff">納品先情報</font></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="order_td" colspan="3">納品先名</td>
              <td colspan="2">{{ orderData.infoName }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">納品先郵便番号</td>
              <td colspan="2">{{ orderData.infoDeliPostcd }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">納品先住所</td>
              <td colspan="2">{{ deliAddress }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">受取人氏名</td>
              <td colspan="2">{{ deliFullName }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">受取人氏名（カナ）</td>
              <td colspan="2">{{ deliFullNameKana }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">受取人電話番号</td>
              <td colspan="2">{{ orderData.infoDeliTel }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">希望納品日</td>
              <td colspan="2">{{ getDateTime(orderData.infoDeliDay, orderData.infoDeliStartTime, orderData.infoDeliEndTime) }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">配送時の連絡事項</td>
              <td colspan="2">{{ orderData.infoDeliNotice }}</td>
            </tr>
          </tbody>
        </table>
        <table v-if="orderData.opExFlag">
          <thead>
            <tr>
              <th  class="order_th" colspan="5"><font color="ffffff">組立設置入力情報</font></th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr>
              <td class="order_td" colspan="3">施主名</td>
              <td colspan="2">{{ orderData.orderNo }}</td>
            </tr> -->
            <tr>
              <td class="order_td" colspan="3">組立先郵便番号</td>
              <td colspan="2">{{ orderData.infoStructPostcd }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">組立先住所</td>
              <td colspan="2">{{ structAddress }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">受取人氏名</td>
              <td colspan="2">{{ structFullName }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">受取人氏名（カナ）</td>
              <td colspan="2">{{ structFullNameKana }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">受取人電話番号</td>
              <td colspan="2">{{ orderData.structTel }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">第一希望納品日</td>
              <td colspan="2">{{ getDate(orderData.btPref1) }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">第二希望納品日</td>
              <td colspan="2">{{ getDate(orderData.btPref2) }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">第三希望納品日</td>
              <td colspan="2">{{ getDate(orderData.btPref3) }}</td>
            </tr>
            <tr>
              <td class="order_td" colspan="3">配送時の連絡事項</td>
              <td colspan="2">{{ orderData.infoStructMessage }}</td>
            </tr>
          </tbody>
        </table>
      </main>
      <section class="item_list">
        <div class="title">
          <h2>注文した商品</h2>
        </div>
        <div v-for="(cart,index) in orderDataList" :key="'cart-' + index">
          <dd-cartitem
            :cartData="cart"
            :type="'history'"
            :odMgId="cart.code"
            :isBeforeDate="isBeforeDate"
            @onShowEstimateModal="onShowEstimateModal"
          />
        </div>
      </section>
    </div>
    <div class="button_wrapper">
      <button type="submit" class="main_btn cancel_btn" @click="cancel()">戻る</button>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {DC_URL} from '../../constants/App'
import * as Api from '../../utils/Api'
import * as AppEc from '../utils/AppEc'
import LoadingModal from '../../components/common/LoadingModal'
import Header from '../components/common/Header'
import CartItem from '../components/common/CartItem'
import OrderPrice from '../components/payment/OrderPrice'

export default {
  name: 'DcOrderHistoryDetail',
  components: {
    'dd-header': Header,
    'dd-loading-modal': LoadingModal,
    'dd-cartitem': CartItem,
    'dd-order-price': OrderPrice
  },
  props: {
  },
  data () {
    return {
      orderNo: '',
      orderDataList: {},
      totalPrice: 0,
      isBeforeDate: false
    }
  },
  computed: {
    orderData: function () {
      return this.orderDataList[0]
    },
    deliFullName: function () {
      let name = (this.orderData.infoDeliLastName ? this.orderData.infoDeliLastName : '') +
        (this.orderData.infoDeliFirstName ? this.orderData.infoDeliFirstName : '')
      return name
    },
    deliFullNameKana: function () {
      let name = (this.orderData.infoDeliLastNameKana ? this.orderData.infoDeliLastNameKana : '') +
        (this.orderData.infoDeliFirstNameKana ? this.orderData.infoDeliFirstNameKana : '')
      return name
    },
    deliAddress: function () {
      let address = (this.orderData.infoDeliState ? this.orderData.infoDeliState : '') +
        (this.orderData.infoDeliCity ? this.orderData.infoDeliCity : '') +
        (this.orderData.infoDeliStreet ? this.orderData.infoDeliStreet : '')
      return address
    },
    structFullName: function () {
      let name = (this.orderData.infoStructLastName ? this.orderData.infoStructLastName : '') +
        (this.orderData.infoStructFirstName ? this.orderData.infoStructFirstName : '')
      return name
    },
    structFullNameKana: function () {
      let name = (this.orderData.infoStructLastNameKana ? this.orderData.infoStructLastNameKana : '') +
        (this.orderData.infoStructFirstNameKana ? this.orderData.infoStructFirstNameKana : '')
      return name
    },
    structAddress: function () {
      let address = (this.orderData.infoStructState ? this.orderData.infoStructState : '') +
        (this.orderData.infoStructCity ? this.orderData.infoStructCity : '') +
        (this.orderData.infoStructStreet ? this.orderData.infoStructStreet : '')
      return address
    },
    paymentType: function () {
      if (this.orderData.payType === 1) {
        return 'クレジットカード'
      } else if (this.orderData.payType === 2) {
        return '銀行振込'
      } else if (this.orderData.payType === 3) {
        return '掛け払い'
      }
      return ''
    }
  },
  methods: {
    getDate: function (date) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      return time
    },
    getDateTime: function (date, start, end) {
      if (!moment(date).isValid()) return ''
      let time = moment(date).format('YYYY/MM/DD')
      if (!start || !end) {
        time += ' 時間指定なし'
      } else {
        time += start < 12 ? ' AM ' : ' PM '
        time += start + ':00'
        time += '～'
        time += end + ':00'
      }
      return time
    },
    getDetailData: function (orderNo) {
      let payload = {
        params: {
          orderNo: orderNo
        }
      }
      axios.get(DC_URL.ORDER + '/history/detail', payload)
        .then(response => {
          this.orderDataList = response.data.data.cartList
          this.orderPrice = response.data.data.orderPrice
          this.isBeforeDate = response.data.data.isBeforeDate
        }).catch(error => {
          Api.handleError(error)
        })
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    onShowEstimateModal: function (estimateData) {
      this.$refs.loadingModalRef.showModal(true)
      // ダイアログ表示
      let modalData = {
        onOk: () => {
        },
        showSuccess: () => {
          this.$refs.loadingModalRef.showModal(false)
        },
        fileName: estimateData.fileName,
        titleDoor: estimateData.titleDoor,
        colorDoor: estimateData.colorDoor,
        titleCabine: estimateData.titleCabine,
        colorCabine: estimateData.colorCabine,
        titleCounter: estimateData.titleCounter,
        colorCounter: estimateData.colorCounter,
        priceData: estimateData.priceData,
        spaceJoincd: estimateData.spaceJoincd,
        dispOrderButton: false,
        dcProductCount: estimateData.dcProductCount,
        isCalcDelivery: true,
        isDrawing: estimateData.isDrawing,
        corpData: estimateData.corpData,
        isProductData: !this.isBeforeDate
      }
      AppEc.showEstimateModal(modalData)
    },
    cancel: function () {
      this.$router.go(-1)
    },
    estimate: function (orderNo) {
      this.$refs.loadingModalRef.showModal(true)
      axios({
        method: 'GET',
        url: DC_URL.CART + '/estimate-history',
        responseType: 'blob',
        params: {
          orderNo: orderNo
        }
      }).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
          this.$refs.loadingModalRef.showModal(false)
        } else {
          var pdf = response.data
          let blob = new Blob([pdf], {type: 'application/xlsx;charset=SJIS'})
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, '見積書.xlsx')
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = '見積書.xlsx'
            link.click()
          }
          this.$refs.loadingModalRef.showModal(false)
        }
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    }
  },
  watch: {
  },
  mounted: function () {
  },
  created: function () {
    if (this.$route.params.orderNo !== undefined) {
      this.orderNo = this.$route.params.orderNo
      localStorage.setItem('OrderNo', JSON.stringify(this.$route.params.orderNo))
    } else {
      this.orderNo = JSON.parse(localStorage.getItem('OrderNo'))
    }
    this.getDetailData(this.orderNo)
  }
}
</script>
<style src="../../css/order/orderDetail.scss" lang="scss" scoped></style>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../css/print.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#order_history_detail {
  background: #FFFFFF;
}

.title {
  width: calc(100% - 60px);
  height: auto;
  padding: 30px;
  font-weight: bold;
  font-size: 1.2em;
}

.main_content {
  max-width: 1000px;
  width: 100%;
  margin: auto;
}

.flex_content{
  height: calc(100% - 134px);
  width: 92%;
  background: #FFFFFF;
  border: 0px;
  border-radius: 0px;
  padding-top: 80px;
  margin:0 auto 20px;
}

.item_list {
  margin: 20px 0;
}

.button_wrapper {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcOrderHistoryDetail.vue